/* eslint-disable max-len */

import React,{useRef} from 'react'
import { Link } from 'react-router-dom';
import ReactModal from 'react-modal'
import ViewAlloffer from './ViewAlloffer'

export default function RelatedOffers({showRelated,setshowRelated,relatedOffers}) {
    const ref = useRef(null);
    const scroll = (scrollOffset) => {
        ref.current.scrollLeft += scrollOffset;
    };
    return (
        <>
            <ReactModal isOpen={showRelated}>
                <ViewAlloffer 
                    setshowRelated={setshowRelated}
                    relatedOffers={relatedOffers}/>
            </ReactModal>
            <div className="border-b border-[#E9EDF4] relative mx-12">
                <div className="bg-[#FFFFFF] absolute -top-3 left-0 text-[#090406] text-base font-semibold" >Related Offers ({relatedOffers.length})</div>
                <div className="text-[#090406] text-xs font-semibold bg-[#FFFFFF] -top-[8px] right-0 absolute cursor-pointer" data-bs-toggle="modal" data-bs-target="#relatedalloffers" onClick={()=>setshowRelated(true)}>View All</div>
            </div>
            <div id="carouselExampleControls2" className="carousel slide relative mt-5 lg:mb-12 mb-10 related-offer" data-bs-ride="carousel" data-bs-interval="false">
                <div className="carousel-inner relative w-full overflow-hidden">
                    <div className="carousel-item active relative float-left w-full" >
                        <div className="flex cursor-pointer" ref={ref} style={{overflowX:'auto',scrollbarColor:'transparent',scrollBehavior:'smooth'}}>
                            {relatedOffers.map((offer,i)=>(
                                <Link key={i} to={`/offers/${offer.offer_code.split('/').join('-')}?code=${encodeURIComponent(offer.offer_code)}`}>
                                    <div className="sm:ml-8 ml-6 min-w-[485px] relative rounded-[10px] shadow-s7 p-2.5 mb-2" key={i}>
                                        <div className="flex ">
                                            <ul className="flex justify-end items-center">
                                                <li>
                                                    <button type="button" className="text-xs font-semibold text-[#FFFFFF] bg-[#44445E] rounded px-1.5 py-1 w-fit absolute right-12 top-2">{offer?.offer_type}</button>
                                                </li>
                                                <li>
                                                    <button type="button" className="text-xs font-semibold text-[#FFFFFF] bg-[#44445E] rounded px-1.5 py-1 w-fit absolute right-2 top-2">{offer?.industrial_pocket}</button>
                                                </li>
                                            </ul>
                                            <div className="flex items-center mt-5">
                                                <img src="/images/related-offer.svg" alt="icon"/>
                                                <div className="pl-5 w-full">
                                                    <ul>
                                                        <li className="font-semibold text-base text-[#090406]">{offer?.offer_code}</li>
                                                        <li className="text-[#44445E] font-normal text-xs13 my-[7px]">Validity: <span className="font-semibold text-[#44445E] text-xs13">{offer?.start_date.split("-").reverse().join("-")?.replace(/-/g,'/')} - {offer?.end_date?.split("-").reverse().join("-").replace(/-/g,'/')}</span><span className="px-2">|</span>Value:<span className="font-semibold text-[#44445E] text-xs13">{offer?.offer_value}</span></li>
                                                        <li className="text-[#44445E] font-normal text-xs2">{offer?.description}</li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Link>
                            ))}
                                
                        </div>
                    </div>
                    
                </div>
                <button
                    onClick={() => scroll(-200)}
                    className="z-0 carousel-control-prev absolute top-0 bottom-0 bg-white opacity-100 w-5 flex items-center justify-center p-0 text-center border-0 hover:outline-none hover:no-underline focus:outline-none focus:no-underline -left-1"
                    type="button"
                    style={{height:'85%'}}
                    data-bs-target="#carouselExampleControls2"
                    data-bs-slide="prev"
                >
                    <span className="inline-block bg-no-repeat" aria-hidden="true">
                        <img src="/images/Union-20.svg" alt="icon" className="w-3 h-3"/>
                    </span>
                    <span className="visually-hidden">Previous</span>
                </button>
                <button
                    onClick={() => scroll(+200)}
                    className="z-0 carousel-control-next  bg-white opacity-100 w-5 absolute top-0 bottom-0 flex items-center justify-center p-0 text-center border-0 -right-2"
                    type="button"
                    style={{height:'85%'}}
                    data-bs-target="#carouselExampleControls2"
                    data-bs-slide="next"
                >
                    <span className="inline-block bg-no-repeat" aria-hidden="true">
                        <img src="/images/chev.svg" />
                    </span>
                    <span className="visually-hidden">Next</span>
                </button>
            </div>
        </>
    )
}
